
<div v-if="scriptLoaded && dropboxChooserIsSupported" @click="openChooser">
    <slot/>
    <button v-if="!this.$slots.default">Open dropbox picker</button>
</div>
